// The WordPress embed builds Tailwind with `important: '.dobyto-wordpress-app'`
// (tailwind.config.wordpress.js), so every utility class in the shipped CSS is
// literally scoped as `.dobyto-wordpress-app .fixed{...}`. BaseModal used to
// teleport straight to `body`, which sits OUTSIDE that ancestor — any modal
// rendered there got zero styles. wordpress.js / wordpress-verify.js call
// setModalTeleportTarget() once at boot so every modal in the embed resolves
// back inside the scoped wrapper, however deep it is mounted.
let target = "body";

export function setModalTeleportTarget(selector) {
    target = selector;
}

export default function modalTeleportTarget() {
    return target;
}
